import ReactDOM from 'react-dom';
import React, { Component } from 'react';
import Star from '../components/Star';
import ParameterErrors from '../errors/ParameterErrors';
import IconButtonNonReact from '../components/IconButtonNonReact';
import PlotStatus from '../site/PlotStatus';
import AssetsManager from '../assets_management/AssetsManager';
import Urls from '../urls/Urls';
import UrlHelper from '../core/UrlHelper';
import Once from '../core/Once';
import eventEnable from '../core/eventEnable';
import ResizeWatcher from '../ui_core/ResizeWatcher';
import DynamicImageDisplayer from '../images/DynamicImageDisplayer';
import PlotDetailedInformationSectionType from './PlotDetailedInformationSectionType';
const {throwNotProvided}=ParameterErrors;
export default class PlotDetailedInformationFloorPlans {
	constructor(props){
		const { siteJsonUnitPlot, showImagesFullScreen, configuration}=props;
		this._configuration = configuration;
		this._siteJsonUnitPlot = siteJsonUnitPlot;
		this._showImagesFullScreen=showImagesFullScreen;
		eventEnable(this);
		this._element = document.createElement('div');
		if(!this._siteJsonUnitPlot.floorPlanImages)return;
		this._element.classList.add('floor-plans');
		this._resized = this._resized.bind(this);
		this._setFloorPlanImageClass = this._setFloorPlanImageClass.bind(this);
		this._setupFromSiteJsonUnitPlot = this._setupFromSiteJsonUnitPlot.bind(this);
		this._dispatchLoaded = this._dispatchLoaded.bind(this);
		this._resizeWatcherParentElement = new ResizeWatcher({element:this._element});
		this._resizeWatcherParentElement.addEventListener('resized', this._resized);
		this._loadedOnce = new Once(this._dispatchLoaded);
		this._imgWrapperElement = document.createElement('div');
		this._imgWrapperElement.classList.add('floor-plan-image-wrapper');
		this._element.appendChild(this._imgWrapperElement);
		this._setupFromSiteJsonUnitPlot();
	}
	_setupFromSiteJsonUnitPlot(){
		this._dynamnicImageDisplayers = [];
		setTimeout(()=>{
			this._imgWrapperElement.innerHTML='';
			this._siteJsonUnitPlot.floorPlanImages.forEach(dynamicImage=>{
				const dynamicImageDisplayer = new DynamicImageDisplayer({
					dynamicImage, 
					parentElement: this._imgWrapperElement,
					resizeWatcherParentElement:this._resizeWatcherParentElement,
					className:'floor-plan-image',
					fitWidthElseHeight:true,
					onClick:()=>this._showImagesFullScreen([dynamicImage]),
					onLoaded:this._loadedOnce.trigger,
					configuration:this._configuration
				});
				this._dynamnicImageDisplayers.push(dynamicImageDisplayer);
			});
		}, 0);
	}
	_resized(){
		const width = this._element.clientWidth;
		if(this._siteJsonUnitPlot.floorPlanImages&&this._siteJsonUnitPlot.floorPlanImages.length>2){
			if(width>600){
				this._setFloorPlanImageClass('floor-plan-images-two-per-row');
				return;
			}
		}
		this._setFloorPlanImageClass('floor-plan-images-one-per-row');
	}
	_setFloorPlanImageClass(newClassName){
		if(this._currentRoomImageClassName){
			this._element.classList.remove(this._currentRoomImageClassName);
		}
		this._currentRoomImageClassName = newClassName;
			this._element.classList.add(newClassName);
	}
	set plot(siteJsonUnitPlot){
		this._siteJsonUnitPlot = siteJsonUnitPlot;
		this._setupFromSiteJsonUnitPlot(siteJsonUnitPlot);
	}
	get element(){
		return this._element;
	}
	get sectionType(){
		return PlotDetailedInformationSectionType.FloorPlans;
	}
	_dispatchLoaded(){
		this.dispatchEvent({type:'loaded'});
	}
}